interface VersionParts {
  major: number;
  minor: number;
  patch: number;
  preRelease?: string;
}

function parseVersion(version: string): VersionParts {
  const [main, preRelease] = version.split('-');
  const [major, minor, patch] = main.split('.').map(Number);
  return { major, minor, patch, preRelease };
}

function compareVersions(v1: VersionParts, v2: VersionParts): boolean {
  if (v1.major !== v2.major) return v1.major > v2.major;
  if (v1.minor !== v2.minor) return v1.minor > v2.minor;
  if (v1.patch !== v2.patch) return v1.patch > v2.patch;

  if (!v1.preRelease && !v2.preRelease) return true;
  if (!v1.preRelease) return true;
  if (!v2.preRelease) return false;

  // Compare pre-release versions lexicographically
  return v1.preRelease >= v2.preRelease;
}

export default function isVersionGreaterOrEqual(version: string, minimumVersion: string): boolean {
  const parsedVersion = parseVersion(version);
  const parsedMinimumVersion = parseVersion(minimumVersion);
  return compareVersions(parsedVersion, parsedMinimumVersion);
}
